import { CLEAR_DATA, LIST_ONDEMAND_HEALTH_RECORD_REQUEST, LIST_ONDEMAND_HEALTH_RECORD_REQUEST_ERROR, LIST_ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS, ONDEMAND_HEALTH_RECORD_REQUEST, ONDEMAND_HEALTH_RECORD_REQUEST_ERROR, ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS, ONDEMAND_REQUEST, ONDEMAND_REQUEST_ERROR, ONDEMAND_REQUEST_SUCCESS } from './Constants';

export const ondemandRequest = (payload) => ({
    type: ONDEMAND_REQUEST,
    payload : payload
});

export const ondemandRequestSuccess = (data) => ({
    type: ONDEMAND_REQUEST_SUCCESS,
    data : data
});

export const ondemandRequestError = () => ({
    type: ONDEMAND_REQUEST_ERROR
});

export const clearOndemandData = () => ({
    type: CLEAR_DATA
});

export const ondemandHealthRecordRequest = (payload) => ({
    type: ONDEMAND_HEALTH_RECORD_REQUEST,
    payload : payload
});

export const ondemandHealthRecordRequestSuccess = (data) => ({
    type: ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS,
    data : data
});

export const ondemandHealthRecordRequestError = () => ({
    type: ONDEMAND_HEALTH_RECORD_REQUEST_ERROR
});

export const ondemandListHealthRecordRequest = () => ({
    type: LIST_ONDEMAND_HEALTH_RECORD_REQUEST
});

export const ondemandListHealthRecordRequestSuccess = (data) => ({
    type: LIST_ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS,
    data : data
});

export const ondemandListHealthRecordRequestError = () => ({
    type: LIST_ONDEMAND_HEALTH_RECORD_REQUEST_ERROR
});